export interface ICompany {
  business_name: string;
  company_name: string;
  tax_id: string;
  fiscal_address: string;
  city: string;
  country: string;
  province: string;
  latitude: string;
  longitude: string;
  business_group: string;
  name: string;
  phone: string;
  email: string;
  is_coworking_too: boolean;
  description?: string;
}

export class Company implements ICompany {
  business_name: string;
  company_name: string;
  tax_id: string;
  fiscal_address: string;
  city: string;
  country: string;
  province: string;
  latitude: string;
  longitude: string;
  business_group: string;
  name: string;
  phone: string;
  email: string;
  is_coworking_too: boolean;
  description?: string;
  constructor(company: ICompany) {
    this.business_name = company.business_name;
    this.company_name = company.company_name;
    this.tax_id = company.tax_id;
    this.fiscal_address = company.fiscal_address;
    this.city = company.city;
    this.country = company.country;
    this.province = company.province;
    this.latitude = company.latitude;
    this.longitude = company.longitude;
    this.business_group = company.business_group;
    this.name = company.name;
    this.phone = company.phone;
    this.email = company.email;
    this.is_coworking_too = company.is_coworking_too;
    this.description = company.description;
  }
}
